import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { productSearchService } from "@/services/api/cresivoxServer";
import { REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const searchProductByImage = createAsyncThunk<
  any,               // ✅ return type (products array)
  FormData,          // ✅ payload type (YOU SEND FORMDATA)
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("searchProductByImage"),

  async (formData, { rejectWithValue }) => {
    try {
      //@ts-ignore
      const response = await productSearchService.getproductsearch(formData);

      const products =
        //@ts-ignore
        response?.data?.data?.products ||
        //@ts-ignore
        response?.data?.products ||
        //@ts-ignore
        response?.data?.data ||
        [];

      //@ts-ignore
      if (response?.httpStatusCode === 200 && Array.isArray(products)) {
        return products;
      }

      return rejectWithValue({
        message: response?.message || "Invalid image search response",
      });
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);
